import { CloseOutlined } from "@ant-design/icons"
import { Button, Flex } from "antd"
import { useTranslation } from "react-i18next"

interface RemoveTileBarProps {
  title?: string
  onRemove: () => void
}

/**
 * Edit mode's Remove control, in a bar of its own above the tile, so it never
 * sits on top of the card's own Refresh / Expand / Export icons.
 */
export const RemoveTileBar = ({ title, onRemove }: RemoveTileBarProps) => {
  const { t } = useTranslation()
  return (
    <Flex justify="flex-end" className="mb-1">
      <Button
        size="small"
        icon={<CloseOutlined />}
        aria-label={
          title
            ? t("portfolio.editLayout.removeTile", { title })
            : t("portfolio.editLayout.removeUntitled")
        }
        // A KPI card is a drag handle; pressing Remove must not start a drag.
        onPointerDown={(event) => event.stopPropagation()}
        onClick={onRemove}
      >
        {t("portfolio.editLayout.remove")}
      </Button>
    </Flex>
  )
}
